import {
	intersect,
	literal,
	nullable,
	number,
	partial,
	string,
	struct,
	union,
} from 'io-ts/Decoder';

import { RefItem as FpcJobRefItem } from '../../fpc/job/RefItem';
import { RefItem as JobRefItem } from '../../job/RefItem';
import { Id as StageId } from '../../job/stage/Id';
import { Id as StatusId } from '../../job/status/Id';
import { Id as OrganizationId } from '../../organization/Id';
import { RefItem as TransactionRefItem } from '../../transaction/RefItem';
import { Id as RecipeCopyId } from '../../whole-house/recipe-copy/Id';
import { Id as TakeOffId } from '../../whole-house/take-off/Id';

export const Type = union(
	intersect(
		struct({
			type: literal('announcement'),
		})
	)(partial({ subType: literal('new-version-available') })),
	intersect(
		struct({
			type: literal('chat'),
			chatChannelArn: string,
			job: JobRefItem,
		})
	)(
		partial({
			transaction: TransactionRefItem,
			chatAnchorId: string,
			reviewItemId: string,
			imageId: string,
			canvasId: string,
			takeOffId: TakeOffId,
			bomItemId: string,
			dueAt: nullable(string),
		})
	),
	intersect(
		struct({
			type: literal('job-assignment'),
			job: JobRefItem,
			stageId: StageId,
		})
	)(
		partial({
			/** The stage's name in the job's organisation, for emails. Absent before ROME-229. */
			stageName: string,
			statusId: StatusId,
		})
	),
	intersect(
		struct({
			type: literal('transaction-assignment'),
			job: JobRefItem,
			transaction: TransactionRefItem,
			stageId: StageId,
		})
	)(
		partial({
			/** The stage's name in the job's organisation, for emails. Absent before ROME-229. */
			stageName: string,
			statusId: StatusId,
			dueAt: nullable(string),
		})
	),
	struct({
		type: literal('transaction-unassigned'),
		job: JobRefItem,
		transaction: TransactionRefItem,
		dueAt: nullable(string),
	}),
	intersect(
		struct({
			type: literal('transaction-completed'),
			job: JobRefItem,
			transaction: TransactionRefItem,
		})
	)(
		partial({
			dueAt: nullable(string),
		})
	),
	struct({
		type: literal('transaction-reworked'),
		job: JobRefItem,
		transaction: TransactionRefItem,
	}),
	struct({
		type: literal('transaction-unallocated'),
		job: JobRefItem,
		transaction: TransactionRefItem,
	}),
	// [ROME-3344]
	intersect(
		struct({
			type: literal('job-completed'),
			job: JobRefItem,
		})
	)(
		partial({
			dueAt: nullable(string),
		})
	),
	// [ROME-4329]
	struct({
		type: literal('job-created'),
		job: JobRefItem,
	}),
	// [ROME-3979]
	intersect(
		struct({
			type: literal('fpc-job-completed'),
			fpcJob: FpcJobRefItem,
		})
	)(
		partial({
			job: JobRefItem,
		})
	),
	// Recipe copy (whole-house) terminal notifications
	struct({
		type: literal('recipe-copy-completed'),
		copyId: RecipeCopyId,
		targetOrganizationId: OrganizationId,
		recipeCount: number,
	}),
	struct({
		type: literal('recipe-copy-failed'),
		copyId: RecipeCopyId,
		targetOrganizationId: OrganizationId,
		failedStage: nullable(string),
	})
);
